import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useEffect } from 'react';
import { Transition } from 'react-transition-group';
import { O as Overlay } from './Overlay-D55MmXA-.js';
import { O as OnCloseContext } from './Context-dY1G4PQg.js';
import { P as Portal } from '../Portal/Portal-CfuGnhf3.js';
import { P as PreventScroll } from '../LocalModules/storm-ui-utils/dist/esm/PreventScroll-DDorLe5h-ClIUFYtJ.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-1m8IJOfp.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { g as getElementFromRef } from '../LocalModules/storm-ui-utils/dist/esm/getElementFromRef-DUWqD2Fg-DUWqD2Fg.js';

const defaultTransitionDuration = 200; // milliseconds

const teardown = toggleEl => {
  // Bring focus back to the toggle element
  if (toggleEl !== undefined) {
    const element = getElementFromRef(toggleEl);
    if (element !== null && element !== void 0 && element.focus) {
      element.focus();
    }
  }
};
const Sheet = ({
  sheetElementId,
  children,
  className = '',
  closeButton,
  closeButtonProps,
  isOpen,
  onClose,
  padding = 'base',
  side = 'bottom',
  withCloseButton = true,
  maxSize = 'default',
  taktId,
  taktValue,
  preventUnmountOnClose,
  transitionDuration = defaultTransitionDuration,
  toggleEl,
  ...rest
}) => {
  const modalContainerRef = useRef(null);
  useEffect(() => () => {
    // focus on toggle element on unmount
    teardown(toggleEl);
  }, [toggleEl]);
  return /*#__PURE__*/React__default.createElement(Transition, {
    timeout: transitionDuration,
    appear: true,
    in: isOpen,
    onExit: () => teardown(toggleEl),
    nodeRef: modalContainerRef
  }, state => {
    if (state === 'exited' && !preventUnmountOnClose) return null;
    return /*#__PURE__*/React__default.createElement(Portal, {
      containerId: sheetElementId
    }, /*#__PURE__*/React__default.createElement(PreventScroll, {
      isScrollEnabled: state === 'exited' && preventUnmountOnClose
    }, /*#__PURE__*/React__default.createElement(TaktIdProvider, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('sheet')
    }, /*#__PURE__*/React__default.createElement(OnCloseContext.Provider, {
      value: onClose
    }, /*#__PURE__*/React__default.createElement(Overlay, _extends({}, rest, {
      className: className,
      closeButton: closeButton,
      closeButtonProps: closeButtonProps,
      modalContainerRef: modalContainerRef,
      onClose: onClose,
      padding: padding,
      state: state,
      side: side,
      withCloseButton: withCloseButton,
      maxSize: maxSize
    }), children)))));
  });
};

export { Sheet as S };
//# sourceMappingURL=Sheet-BWdQGx8_.js.map
